<script lang="ts">
    import {_} from 'svelte-i18n'
    import {createEventDispatcher} from 'svelte';
    import IconButton from '@smui/icon-button';
    import MessageInput from './MessageInput.svelte';
    import type {Conversation, MessageInputResult, Session} from './types';
    import {DefinedMessageType, Role} from './types';
    import {escapeHtml, isPaused, isPending, isStarted, wasEnded} from './service/util';
    import type {MessageFormatter} from 'svelte-i18n/types/runtime/types';

    const dispatch = createEventDispatcher();

    export let conversation: Conversation;
    export let session: Session;
    export let value: string = '';
    let valueValid: boolean = false;
    let inputWritable: boolean;
    let inputSubmittable: boolean;

    function addMessage() {
        if (!valueValid) {
            return;
        }
        const newMessage: MessageInputResult = {
            text: escapeHtml(value)
        };
        dispatch('message-add', newMessage);
        value = '';
    }

    function onMessageInputSubmit(e: CustomEvent<void>) {
        addMessage();
    }

    $: inputWritable = isInputWritable(conversation);
    $: inputSubmittable = isInputSubmittable(conversation, valueValid);

    function isInputWritable(c: Conversation) {
        return (isPending(conversation) && session.roles.includes(Role.OPERATOR)) || (isStarted(c) && !isPaused(c));
    }

    function isInputSubmittable(c: Conversation, valueValid: boolean) {
        return isInputWritable(c) && valueValid;
    }

    function getInputPlaceholder(c: Conversation, format: MessageFormatter): string {
        if (isPending(c)) {
            return format('message.ContactWaitingClient');
        }
        if (wasEnded(c)) {
            return format('chat.ChatAlreadyEnded');
        }
        if (isPaused(c)) {
            return format('chat.ChatIsSuspended');
        }
        return format('message.YouCanType');
    }
</script>

<div style="display: flex; box-sizing: border-box;">
    <MessageInput bind:value bind:valueValid disabled={!inputWritable} placeholder={getInputPlaceholder(conversation, $_)} on:message-submit={onMessageInputSubmit} predefinedMessagesType={session.roles.includes(Role.OPERATOR) ? DefinedMessageType.OPERATOR_CHAT_MESSAGE : null} />
    <IconButton class="material-icons" on:click={addMessage} title={$_('message.Send')} disabled={!inputSubmittable}>send</IconButton>
</div>